import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "🔄", key: "allTheTime" },
  { emoji: "📅", key: "prettyOften" },
  { emoji: "🍂", key: "seasonally" },
  { emoji: "🐌", key: "rarely" },
  { emoji: "🔒", key: "never" },
]

export default function HairstyleFrequencyPage() {
  return (
    <RadioCardListPage translationKey="hairstyleFrequency" options={OPTIONS} />
  )
}
